import axios from '@/libs/api.request';

export const getBrandList = data => {
    return axios.request({
        url: 'api/productManagement/brand/getBrandList',
        data: data,
        method: 'post'
    });
};

export const saveBrand = data => {
    return axios.request({
        url: 'api/productManagement/brand/saveBrand',
        data: data,
        method: 'post'
    });
};


export const getPackageList = data => {
    return axios.request({
        url: 'api/systemManagement/packageManagement/getPackageList',
        data: data,
        method: 'post'
    });
};

export const savePackage= data => {
    return axios.request({
        url: 'api/systemManagement/packageManagement/savePackage',
        data: data,
        method: 'post'
    });
};